module.exports = __webpack_public_path__ + "media/blog/bar-chart-8a59cb15.png";